import React, { useMemo } from "react";
import BaseTable from "@components/DataTable/BaseTable";
import type { Header } from "@components/DataTable/CustomDataTable.types";
import Paper from "@components/Paper/Paper";
import type { MarpolAnnexI } from "@features/vessel-call/vessel-call-status/PortServices/store/usePortServicesForm.store";
import { useTranslation } from "react-i18next";

export type MarpolAnnexRow = {
  id: number;
  marpolAnnexIOil: string;
  quantityM3: string;
};

interface MarpolAnnexGridProps {
  rows?: MarpolAnnexI[];
}

const MarpolAnnexGrid: React.FC<MarpolAnnexGridProps> = ({ rows }) => {
  const { t } = useTranslation();
  const LANG_BASE = "vessel-call.marpol-annex1";

  const headers: Header[] = useMemo(
    () => [
      {
        field: "marpolAnnexIOil",
        columnName: t(`${LANG_BASE}.grid-headers.marpolAnnexIOil`),
      },
      {
        field: "quantityM3",
        columnName: t(`${LANG_BASE}.grid-headers.quantityM3`),
      },
    ],
    [t],
  );

  const mappedRows: MarpolAnnexRow[] = (rows ?? []).map((p, id) => {
    return {
      id,
      marpolAnnexIOil:
        p.marpolAnnexIOil === "Other (Specify)" ? p.otherSpecifyDetails : p.marpolAnnexIOil || "-",
      quantityM3: p.quantityM3?.toString() || "-",
    };
  });

  const tableTitle = t(`${LANG_BASE}.title`);

  return (
    <Paper variant="outlined">
      <p className="font-bold mb-4">{tableTitle}</p>
      <BaseTable rows={mappedRows} headers={headers} />
    </Paper>
  );
};

export default MarpolAnnexGrid;
